export const COMMON = {
  BOOLEAN: {
    TRUE: 'COMMON.BOOLEAN.TRUE', // Si
    FALSE: 'COMMON.BOOLEAN.FALSE', // No
  },
  MESSAGES: {
    SUCCESS: {
      CREATED: 'COMMON.MESSAGES.SUCCESS.CREATED', // Se creó correctamente.
      UPDATED: 'COMMON.MESSAGES.SUCCESS.UPDATED', // Se actualizó correctamente.
      DELETED: 'COMMON.MESSAGES.SUCCESS.DELETED', // Se eliminó correctamente.
    },

    ERROR: {
      CREATED: 'COMMON.MESSAGES.ERROR.CREATED', // No se pudo crear el registro. Intenta nuevamente.
      UPDATED: 'COMMON.MESSAGES.ERROR.UPDATED', // No se pudo actualizar el registro. Intenta nuevamente.
      DELETED: 'COMMON.MESSAGES.ERROR.DELETED', // No se pudo eliminar el registro. Intenta nuevamente.
      CONNECTION: 'COMMON.MESSAGES.ERROR.CONNECTION', // No se pudo completar la operación. Verifica tu conexión e inténtalo nuevamente.
      UNEXPECTED: 'COMMON.MESSAGES.ERROR.UNEXPECTED', // Ocurrió un error inesperado. Intenta nuevamente.
      CONFLICT: 'COMMON.MESSAGES.ERROR.CONFLICT', // No se pudo completar la operación porque existe un conflicto con la información. Intenta actualizar los datos e inténtalo nuevamente.
      VALIDATIONS: 'COMMON.MESSAGES.ERROR.VALIDATIONS', // Algunos datos no cumplen las condiciones requeridas. Verifica la información e inténtalo nuevamente.
      CONTROL_NOT_FOUND: 'COMMON.MESSAGES.ERROR.CONTROL_NOT_FOUND', // No se encontró el control requerido. Verifica la información e inténtalo nuevamente.
    },

    WARNING: {
      DELETE_CONFIRMATION: 'COMMON.MESSAGES.WARNING.DELETE_CONFIRMATION', // ¿Estás seguro de que deseas eliminar este registro? Esta acción no se puede deshacer.
      UNSAVED_CHANGES: 'COMMON.MESSAGES.WARNING.UNSAVED_CHANGES', // Tienes cambios sin guardar. Si continúas, se perderán.
    },

    INFO: {
      LOADING: 'COMMON.MESSAGES.INFO.LOADING', // Procesando solicitud.
      NO_RESULTS: 'COMMON.MESSAGES.INFO.NO_RESULTS', // No se encontraron resultados.
      REQUIRED_FIELDS: 'COMMON.MESSAGES.INFO.REQUIRED_FIELDS', // Completa los campos obligatorios.
    },
  },

  VALIDATION: {
    REQUIRED: 'COMMON.VALIDATION.REQUIRED', // Campo obligatorio.
    EMAIL: 'COMMON.VALIDATION.EMAIL', // Correo electrónico inválido.
    MIN_LENGTH: 'COMMON.VALIDATION.MIN_LENGTH', // El valor es demasiado corto.
    MAX_LENGTH: 'COMMON.VALIDATION.MAX_LENGTH', // El valor excede la longitud permitida.
    INVALID_VALUE: 'COMMON.VALIDATION.INVALID_VALUE', // Valor inválido.
  },

  PLACEHOLDER: {
    SEARCH: 'COMMON.PLACEHOLDER.SEARCH', // Buscar...
    SELECT: 'COMMON.PLACEHOLDER.SELECT', // Selecciona una opción
    DATE: 'COMMON.PLACEHOLDER.DATE', // Selecciona una fecha
  },
  STATUS: 'COMMON.STATUS',

  ACTIONS: {
    ACCEPT: 'ACTIONS.ACCEPT', // Aceptar / Accept
    CANCEL: 'ACTIONS.CANCEL', // Cancelar / Cancel
    CONSULT: 'ACTIONS.CONSULT', // Consultar / Consult
    EDIT: 'ACTIONS.EDIT', // Editar / Edit
    DELETE: 'ACTIONS.DELETE', // Eliminar / Delete
    CREATE: 'ACTIONS.CREATE', // Crear / Create
    BACK: 'ACTIONS.BACK', // Regresar / Back
  },
  COLUMNS: {
    ACTIONS: 'COLUMNS.ACTIONS', // Acciones / Actions
    DETAILS: 'COLUMNS.DETAILS',
    CODE: 'COLUMNS.CODE',
    NAME: 'COLUMNS.NAME',
    DESCRIPTION: 'COLUMNS.DESCRIPTION',
    QUANTITY: 'COLUMNS.QUANTITY',
    QUANTITY_SHORT: 'COLUMNS.QUANTITY_SHORT', // Cant. / Qty.: columnas angostas de tablas de detalle
    SUBTOTAL: 'COLUMNS.SUBTOTAL',
    TOTAL: 'COLUMNS.TOTAL',
  },
  DATE_RANGE: {
    LABEL: 'COMMON.DATE_RANGE.LABEL', // Rango de fechas / Date range
  },
  EMAIL: 'MASTERS.USER.FORM.EMAIL',
} as const;
